import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import RecommendedSection from './components/RecommendedSection';
import HotSection from './components/HotSection';
import NewUpdatesSection from './components/NewUpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'yy漫画网',
    url: 'https://yymanhua.com',
    description: 'yy漫画网为您提供免费韩漫资源，支持在线下拉式阅读，涵盖丰富韩国漫画题材，让您轻松浏览精彩故事，无需付费即可开始阅读。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yymanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'yy漫画网',
    url: 'https://yymanhua.com',
    description: '韩漫免费在线阅读平台',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <main>
        <HeroBanner />
        <CategoryNav />
        <RecommendedSection />
        <HotSection />
        <NewUpdatesSection />
        <FeaturesSection />
        <FAQSection />
      </main>
    </>
  );
}